import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'timeFromInt'
})
export class TimeFromIntPipe implements PipeTransform {

    transform(value: any, args?: any): any {
        const hours = Math.floor(value / 60);
        const minutes = value - (hours * 60);

        let strHours = String(hours);
        let strMinutes = String(minutes);
        if (hours < 10) {
            strHours = '0' + String(hours);
        }
        if (minutes < 10) {
            strMinutes = '0' + String(minutes);
        }

        return strHours + ':' + strMinutes;

    }

}
